import {storySummaryBase} from "@/lib/api/sanity/queries/storyBase";

const storiesBySite = `
* [_type == 'story']
${storySummaryBase}
[$site in categories[].site]
`
export default storiesBySite
